const pushEvent = (window && window.Logger) || undefined;

export const intializeLogger = (pageName, pageData) => {
  if (pushEvent) {
    const config = {};
    config.env = ENV ? `${pageName}_${ENV}` : `${pageName}_dev`;
    if (config.env === `${pageName}_prod` || config.env === `${pageName}_preprod` || config.env === `${pageName}_stage-aws`) {
      config.debug = false;
    }
    config.meta = pageData;
    config.service = "link_payment_form_ui";
    if (typeof pushEvent.log === "function") {
      pushEvent.init(config);
    }
  }
};

export const logEvent = obj => {
  if (pushEvent && typeof pushEvent.log === "function") {
    pushEvent.log(obj);
  }
};



// WEBPACK FOOTER //
// ./utils/logger.js